import { registerDecorator, ValidationOptions, ValidationArguments } from 'class-validator';
import {RegexConstants} from "../constants/regex.constants";

export function MeetsPasswordCriteria(validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: 'meetsPasswordCriteria',
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: {
                validate(value: any, args: ValidationArguments) {
                    return RegexConstants.HAS_MINIMUM_8_CHARS.test(value) && 
                        RegexConstants.PASSWORD_HAS_UPPERCHAR.test(value) && 
                    RegexConstants.PASSWORD_HAS_NUMBER.test(value) && 
                    RegexConstants.PASSWORD_HAS_SYMBOL.test(value);
                },
            },
        });
    };
}